import useI18n from '@i18n';

import externalLinks from '@config/external-links.json';
import BaseSemanticLink from '@base/BaseSemanticLink';
import BaseContainer from '@base/BaseContainer';

import { companyName } from '@config/globalDomain';
import I18nLink from './I18nLink';

import WithdrawalMethods from './WithdrawalMethods';
import { IFooterLinkItem } from './interfaces';

import links from './config';
import SocialIcons from './Social';

const contacts: IFooterLinkItem[] = {
    epn: [
        {
            key: 'Support',
            id: 'FooterSupportLink',
            href: externalLinks.mail,
        },
        {
            key: 'Your suggestions',
            id: 'FooterQualityLink',
            href: externalLinks.quality,
        },
    ],
    epncpa: [],
}[process.env.NEXT_PUBLIC_PROJECT_NAME];

const Footer: React.FC<{ isAuth: boolean }> = ({ isAuth }) => {
    const { t, locale } = useI18n('Base');

    const hideChangeLang = process.env.NEXT_PUBLIC_PROJECT_LOCALES.split(',').length < 2;
    const isEpncpa = process.env.NEXT_PUBLIC_PROJECT_NAME === 'epncpa';

    return (
        <footer className="border-t pt-[32px] md:pt-[40px] pb-[64px] border-blueGray-200">
            <BaseContainer>
                <div className="flex flex-col mb-[32px] sm:flex-row sm:justify-between xs:mb-[24px] sm:mb-[32px] md:mb-[24px]">
                    <div
                        className={`${
                            locale === 'en' ? 'max-w-[500px]' : 'max-w-[583px]'
                        } mb-[32px] xs:mb-[24px] sm:mb-[32px] md:mb-[24px]`}
                    >
                        <div
                            className={
                                isEpncpa
                                    ? 'flex flex-wrap xs:justify-between md:justify-start gap-[16px]'
                                    : 'flex flex-wrap gap-[16px]'
                            }
                        >
                            {links.map((link: IFooterLinkItem) => {
                                if (typeof link.isVisible === 'boolean' && !link.isVisible)
                                    return null;
                                if (link.isAuth && link.isAuth !== isAuth) return null;

                                return (
                                    <span
                                        className="whitespace-nowrap last:mr-0 text-blueGray-800 text-[16px]"
                                        key={link.key}
                                    >
                                        <BaseSemanticLink
                                            className="hover:underline"
                                            id={link.id}
                                            to={link.href.replace(':locale', locale)}
                                        >
                                            {t(link.key, { companyName })}
                                        </BaseSemanticLink>
                                    </span>
                                );
                            })}
                        </div>
                        <div className="flex flex-wrap">
                            {contacts &&
                                contacts.map(contact => (
                                    <span
                                        className="mt-6 mr-6 whitespace-nowrap last:mr-0"
                                        key={contact.key}
                                    >
                                        <span className="text-blueGray-500 text-[14px]">
                                            {t(contact.key)}:{' '}
                                        </span>
                                        <BaseSemanticLink
                                            className="text-blueGray-800 hover:underline  text-[14px]"
                                            id={contact.id}
                                            to={`mailto: ${contact.href}`}
                                        >
                                            {contact.href}
                                        </BaseSemanticLink>
                                    </span>
                                ))}
                        </div>
                    </div>
                    <div className="flex flex-row items-center justify-center w-auto h-full xs:w-full sm:justify-start sm:w-auto sm:flex-col gap-[32px] sm:gap-[24px]">
                        {!hideChangeLang && <I18nLink />}
                        <SocialIcons />
                    </div>
                </div>

                <div className="flex flex-col items-center justify-between sm:flex-row gap-[24px] sm:gap-0">
                    <div className="w-full sm:max-w-1/2">
                        <WithdrawalMethods />
                    </div>
                    <p className="text-right text-[10px] sm:text-[12px] min-w-[100px] text-blueGray-300">
                        ＠ {new Date().getFullYear()} {companyName}
                    </p>
                    {isEpncpa && (
                        <p className="mt-1 text-center sm:text-right text-[10px] sm:text-[12px] text-blueGray-300 xs:max-w-[428px]">
                            Profit Affiliate Limited, Flat A 8/F, Kingswell Commercial Tower, 171
                            Lockhart Road, Wan Chai, Hong Kong
                        </p>
                    )}
                </div>
            </BaseContainer>
        </footer>
    );
};

export default Footer;
